export enum IconsEnum{
    ERROR= './assets/icon/error.svg',
    SUCCESS= './assets/icon/success.svg',
    IN_PROGRESS= './assets/icon/in-progress.svg',
  }